const SvgIcon = ({ size = '24', color = '#a59e9e'}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="svg1244"
    width={size}
    height={size}
    fill="none"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      id="path1242"
      fill={color}
      fillOpacity="0.98"
      strokeWidth="1"
      d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m9.517 10.8H18.2a17.64 17.64 0 0 0-2.15-7.492 9.61 9.61 0 0 1 5.467 7.492m-8.881-8.368c1.242 1.637 2.912 4.536 3.152 8.368H8.436c.167-3.115 1.193-6.034 2.941-8.369.207-.012.413-.031.623-.031.215 0 .425.02.636.032m-4.61.84c-1.181 2.27-1.863 4.842-1.99 7.528H2.483a9.61 9.61 0 0 1 5.543-7.528M2.483 13.2h3.569c.163 2.855.798 5.374 1.867 7.476A9.61 9.61 0 0 1 2.483 13.2m8.857 8.368C9.659 19.53 8.666 16.675 8.45 13.2h7.335c-.25 3.328-1.34 6.235-3.124 8.366-.218.015-.437.034-.661.034-.223 0-.44-.02-.66-.032m4.813-.927C17.3 18.488 18 15.96 18.183 13.2h3.333a9.6 9.6 0 0 1-5.363 7.441"
    ></path>
  </svg>
);

export default SvgIcon;
